<template>
  <loader :loading="loading" v-if="loading" />
  <div class="dashboard-container" v-else>
    <div class="page-breadcrumb">
      <div class="row mb-5 flex flex-wrap align-items-center w-100 no-gutters">
        <div class="col-auto mr-3 ">
          <h4 class="page-title">Dashboard</h4>
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Library
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="group-by col-auto ">
          <primary-select
            type="text"
            name="Group by"
            v-model="selected.group_by"
            :options="groups"
          />
        </div>
<!--        <div class="date-delay col-md-auto col-12 " style="margin-top: -26px;">-->
<!--          <div class="date-showing flex-wrap">-->
<!--            <div class="date-box start-end-margin">-->
<!--              <h1 class="header my-2">Start Date</h1>-->
<!--              <div class="date date-font white_space" @click="selectTime(true, start_time)">-->
<!--                {{ from }}-->
<!--              </div>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="to date-font">to</div>&ndash;&gt;-->
<!--            <div class="date-box start-end-margin">-->
<!--              <h1 class="header ">End Date</h1>-->
<!--              <div class="date date-font white_space" @click="selectTime(false, end_time)">-->
<!--                {{ to }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <datetime-->
<!--            ref="date-picker"-->
<!--            v-model="date_and_time"-->
<!--            type="datetime"-->
<!--            :use12-hour="false"-->
<!--            :flow="['date', 'time']"-->
<!--            input-class="date-time-picker-input"-->
<!--            input-style="display: none"-->
<!--          ></datetime>-->
<!--        </div>-->

        <div class="inputs date-inputs flex-wrap ml-0 d-flex ml-auto mr-0">
          <div class="equal-field date-picker my-1 mr-2">
            <date-time-picker
                    header="START DATE"
                    header_font_size="12"
                    header_font_weight="700"
                    :initial_time="new Date(start_time)"
                    @getTime="selectTime(true, start_time)"
            ></date-time-picker>
          </div>
          <div class="equal-field date-picker mr-0 my-1">
            <date-time-picker
                    header="END DATE"
                    header_font_size="12"
                    header_font_weight="700"
                    :initial_time="new Date(end_time)"
                    @getTime="selectTime(false, end_time)"
            ></date-time-picker>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Overview of the {{ delayName }}</h4>
            <ul
              class="nav nav-pills custom-pills owm"
              id="pills-tab"
              role="tablist"
              v-if="stat"
            >
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#users"
                  role="tab"
                  aria-selected="true"
                >
                  <span class="text-muted">SMS Recieved</span>
                  <h3 class="mb-0 text-dark">
                    <!-- {{ statistic.recieved.toFixed(2) }} -->
                    {{ stat.client_recv && stat.client_recv.toFixed(2) }}
                    <span class="text-info font-12">
                      <i class="fa fa-arrow-up" aria-hidden="true"></i>
                      18.6
                    </span>
                  </h3>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#revenue"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="text-muted">SMS Sent</span>
                  <h3 class="mb-0 text-dark">
                    <!-- {{ statistic.sent.toFixed(2) }} -->
                    {{ stat.client_sent && stat.client_sent.toFixed(2) }}
                  </h3>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-cost-tab"
                  data-toggle="pill"
                  href="#cost"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="text-muted">Cost</span>
                  <h3 class="mb-0 text-dark">
                    <!-- {{ statistic.cost.toFixed(2) }} -->
                    {{ stat.client_cost && stat.client_cost.toFixed(2) }}
                  </h3>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-revenue-tab"
                  data-toggle="pill"
                  href="#revenue"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="text-muted">Revenue</span>
                  <h3 class="mb-0 text-dark">
                    <!-- {{ statistic.revenue.toFixed(2) }} -->
                    {{ null }}
                  </h3>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profit-tab"
                  data-toggle="pill"
                  href="#profit"
                  role="tab"
                  aria-selected="false"
                >
                  <span class="text-muted">Profit</span>
                  <h3 class="mb-0 text-dark">
                    <!-- {{ statistic.net_profit.toFixed(2) }} -->
                    {{ stat.profit && stat.profit.toFixed(2) }}
                  </h3>
                </a>
              </li>
            </ul>
          </div>
          <div class="options">
            <div class="step">
              <primary-select
                v-model="selected.delay"
                type="text"
                class="select-delay"
                :options="delays"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="charts_container" id="sms_result">
      <div class="charts_div">
        <card-componet
          subTilite="SMS Delivery"
          :selectLast="true"
          @clicked="showBody"
        >
          <sms-delivery
            :options="{ responsive: false, maintainAspectRatio: false }"
            :width="510"
            :data="graphDataDlvr"
            v-show="!showDelivery"
          ></sms-delivery>
        </card-componet>
      </div>
      <div class="charts_div mt-4">
        <card-componet
          subTilite="SMS Received"
          :selectLast="true"
          @clicked="showBody"
        >
          <sms-received
            v-show="!showReceived"
            :options="{ responsive: false, maintainAspectRatio: false }"
            :width="510"
            :data="graphDataRcvr"
          ></sms-received>
        </card-componet>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DateTimePicker: () => import("@/components/DateTime"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    CommitChart: () => import("@/components/Charts/Dashboard/CommitChart.js"),
    BarChart: () => import("@/components/Charts/Dashboard/BarChart.js"),
    BarChartSecond: () => import("@/components/Charts/Dashboard/BarChart2.js"),
    CompaniesChart: () =>
      import("@/components/Charts/Dashboard/CompaniesChart.js"),
    ResellersLineChart: () =>
      import("@/components/Charts/Dashboard/ResellersLineChart.js"),
    SmsDelivery: () => import("@/components/Charts/Dashboard/SmsDelivery.vue"),
    SmsReceived: () => import("@/components/Charts/Dashboard/SmsReceived.vue"),
    CardComponet: () => import("@/components/CardComponent.vue"),
    Loader: () => import("@/components/Loader.vue"),
  },
  props: ["ldata"],
  data: () => ({
    delays: [
      { name: "Hour", value: "hour" },
      { name: "Day", value: "day" },
      { name: "Week", value: "week" },
      { name: "Month", value: "month" },
    ],
    groups: [
      { name: "Group by", value: null },
      { name: "username", value: "user_id" },
    ],
    selected: {
      delay: "hour",
      group_by: null,
    },
    start_time: 0,
    end_time: 0,
    is_start: true,
    date_and_time: "",
    interval: null,
    data: [],
    loading: true,
    showDelivery: false,
    showReceived: false,
    delay_name: "Hour",
    stat: null,
    stats: [],
  }),
  computed: {
    statistic() {
      const initStatistic = {
        recieved: 0,
        sent: 0,
        cost: 0,
        revenue: 0,
        net_profit: 0,
      };

      const mergeSum = (obj1, obj2) => {
        return Object.keys(obj1).reduce((acc, key) => {
          if (obj2.hasOwnProperty(key) && !isNaN(parseFloat(obj2[key]))) {
            acc[key] = obj1[key] + obj2[key];
          }
          return acc;
        }, initStatistic);
      };

      return this.data.reduce(
        (acc, obj) => (acc = mergeSum(acc, obj)),
        initStatistic
      );
    },
    from() {
      return format(this.start_time, "YYYY:MM:DD HH:mm:ss");
    },
    to() {
      return format(this.end_time, "YYYY:MM:DD HH:mm:ss");
    },
    chartData() {
      // this.from = this.to = new Date();
      // this.to = format(this.to, "YYYY:MM:DD HH:mm:ss");
      // var length = 0;

      // if (this.interval === "1 hour") {
      //   this.from.setHours(this.from.getHours() - 1);
      // }
      // if (this.interval === "24 hour") {
      //   this.from.setHours(this.from.getHours() - 24);
      //   length = 24;
      // }
      // if (this.interval === "7 days") {
      //   this.from.setHours(this.from.getDay() - 7);
      //   length = 7;
      // }
      // if (this.interval === "30 days") {
      //   this.from.setHours(this.from.getDay() - 30);
      // }

      // this.from = format(this.from, "YYYY:MM:DD HH:mm:ss");

      return [
        [0, 0],
        // [1167609600000, 0.7537],
        // [1167696000000, 0.7537],
        // [1167782400000, 0.7559],
        // [1167868800000, 0.7631],
        // [1167955200000, 0.7644],
      ];
    },
    graphDataDlvr() {
      if (!this.stats.length) {
        return [[0, 0]];
      }
      return this.stats.map(this.transformStatsDlvr);
    },
    graphDataRcvr() {
      if (!this.stats.length) {
        return [[0, 0]];
      }
      return this.stats.map(this.transformStatsRcvr);
    },
    delayName() {
      const finded_delay = this.delays.find(
        (delay) => delay.value === this.selected.delay
      );
      return finded_delay.name;
    },
  },
  watch: {
    date_and_time(d) {
      if (!d) {
        return;
      }
      if (this.is_start) {
        this.start_time = d;
      } else {
        this.end_time = d;
      }
      this.GetStat();
    },
    "selected.delay": function () {
      this.GetStat();
    },
    "selected.group_by": function () {
      this.GetStat();
    },
  },
  created: async function () {
    this.interval = "1 hour";
    this.SetCurrentDate();
    await this.getDashboardData();
  },
  methods: {
    clickDatePickerOriginal() {
      this.$refs["date-picker"].$el.children[0].click();
    },
    SetCurrentDate() {
      const current_date = new Date();
      this.start_time = new Date(current_date.setHours(0, 0, 0)).toGMTString();
      this.date_and_time = this.start_time;
      this.end_time = new Date(current_date.setHours(23, 59, 59)).toGMTString();
    },
    selectTime(is_start, time) {
      this.is_start = is_start;
      this.clickDatePickerOriginal();
    },
    showBody(data) {
      if (data[1] == "SMS Delivery") {
        console.log(data);
        this.showDelivery = data[0];
      } else {
        this.showReceived = data[0];
      }
    },
    GetStat() {
      this.loading = true;
      const start_time_parse = Date.parse(this.start_time);
      const end_time_parse = Date.parse(this.end_time);
      this.$store
        .dispatch("GetStat", {
          start_time: start_time_parse / 1000,
          end_time: end_time_parse / 1000,
          step: this.selected.delay || "hour",
          group: this.selected.group_by || null,
        })
        .then((res) => {
          console.log(res);
          this.stats = res;
          this.stat = res[0];
        })
        .catch((err) => {
          this.$snotify.error(err, { timeout: 6000 });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getStatistic(delay) {
      this.interval = delay;
      this.getDashboardData();
    },
    daysInMonth(year, month) {
      return new Date(year, month + 1, 0).getDate();
    },
    getDashboardData: async function () {
      this.loading = true;
      const { items } = await this.$store.dispatch(
        "GetDashboardData",
        this.interval
      );
      this.data = items;
      this.loading = false;
    },
    weeksCount(y, m) {
      var first = new Date(y, m, 1).getDay();
      var last = 32 - new Date(y, m, 32).getDate();

      // logic to calculate number of weeks for the current month
      return Math.ceil((first + last) / 7);
    },
    transformStatsDlvr(item) {
      return [item.report_time * 1000, item.client_sent || 0];
    },
    transformStatsRcvr(item) {
      return [item.report_time * 1000, item.client_recv || 0];
    },
  },
};
</script>

<style>
/* .highcharts-container {
  width: 100% !important;
}
.highcharts-container svg {
  width: 100%;
}
.highcharts-container svg rect {
  width: 100%;
} */
</style>

<style lang="scss" scoped>
.page-breadcrumb {
  font-family: "Helvetica Neue";

  .group-by {
    width: 160px;
  }
  .date-delay {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-grow: 1;

    .date-showing {
      display: flex;
      width: 500px;

      .date-font {
        font-size: 20px;
        color: #2962ff;
      }
      .to {
        width: 40px;
        padding-top: 20px;
      }
      .date-box {
        flex-grow: 1;

        .header {
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
        }
        .date {
          cursor: pointer;
        }
      }
    }
  }
  .page-title {
    margin-bottom: 0;
    font-size: 16px;
  }
  .breadcrumb {
    padding: 0;
    margin: 0;
    background: 0 0;
    font-size: 12px;
  }
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  list-style: none;
  background-color: #eef5f9;
  border-radius: 2px;
}
.breadcrumb-item {
  display: flex;
}
ol li {
  margin: 5px 0;
}
.breadcrumb-item.active {
  color: #6c757d;
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.text-info {
  color: #2962ff !important;
}
.card {
  border: none;
  .card-title {
    position: relative;
    font-weight: 600;
    margin-bottom: 10px;
    font-family: "Helvetica Neue";
    font-size: 16px;
    color: #3e5569;
  }
  .options {
    padding: 0 20px;

    .step {
      width: 180px;
      float: right;
    }
  }
}
.font-12 {
  font-size: 12px;
}
.nav-pills .nav-link {
  border-radius: 0;
  opacity: 0.7;
}
.nav-pills.custom-pills .nav-link.active {
  color: #2962ff;
  opacity: 1;
  background-color: transparent;
  border-bottom: 2px solid #2962ff;
}
.text-muted {
  color: #a1aab2 !important;
  font-size: 14px;
  font-family: "Helvetica Neue";
}
.text-orange {
  color: #fb8c00 !important;
}
.mdi-arrow-down:before {
  content: "\F045";
}
.mdi-arrow-up:before {
  content: "\F05D";
}
.mdi-set,
.mdi:before {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transform: translate(0, 0);
}
.text-dark {
  color: #343a40 !important;
  font-size: 24px;
  font-family: "Helvetica Neue";
}
.dashboard-container {
  font-family: Helvetica Neue;
  padding: 20px;
  background-color: #eef5f9;
  .statistic-header {
    display: flex;
    span {
      font-size: 22px;
      color: #000;
      margin: 0 10px;
      font-weight: 500;
      margin-right: 20px;
    }
    .time {
      color: gray;
      font-size: 22px;
      font-weight: 500;
      word-spacing: 15px;
    }
  }
  .statistic-container {
    display: flex;
    margin: 20px 0;
    .statistic-box {
      width: 25%;
      border: 1px solid #dee0e3;
      border-radius: 5px;
      background-color: #edeff5;
      box-shadow: 0 2px 7px 0 hsla(225, 9%, 75%, 0.2);
      height: 140px;
      margin-right: 20px;
      padding: 15px;
      font-size: 28px;
      color: black;
      font-weight: 600;
      text-align: center;
      display: inline-grid;
    }
  }
  .statistic-container :last-child {
    margin-right: 0;
  }
  .chart-container {
    display: flex;
    margin-bottom: 20px;
    .first {
      margin-right: 20px;
      width: 728px;
    }
    .second {
      width: 260px;
      height: 170px;
      margin-bottom: 20px;
    }
    .third {
      width: 260px;
      height: 170px;
    }
    .forth {
      width: 494px;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    }
  }
}
@media (max-width: 882px) {
  .start-end-margin{
    margin-top: 16px;
  }
}
</style>

